import React, { ReactNode, ReactNodeArray } from "react";
import EpiComponent from "@episerver/spa-core/EpiComponent";
import MobileNavigationMenuBlockData from "../../../Models/Content/MobileNavigationMenuBlockData";
import MobileNavigationMenu from "./MobileNavigationMenu";

export default class MobileNavigationMenuBlock extends EpiComponent<MobileNavigationMenuBlockData> {
  public render(): ReactNode | ReactNodeArray | null {
    let cssClasses: Array<string> = ["mobile-navigation-menu-block"];
    // if (this.props.data.padding?.value) cssClasses.push(this.props.data.padding?.value);
    // if (this.props.data.margin?.value) cssClasses.push(this.props.data.margin?.value);

    return (
      <div className={cssClasses.join(" ")}>
        <MobileNavigationMenu iContent={this.props.data} context={this.getContext()} />
      </div>
    );
  }
}
